//let ranges = document.querySelectorAll("div:not(.member-country) .custom-radio input")
const ranges = Array.from(document.querySelectorAll('.brand-product-range--toggles .custom-radio input'))

ranges.forEach( range => {
    range.addEventListener('change', e => {
        let searchParams = new URLSearchParams(window.location.search)
        searchParams.set('range', range.getAttribute('id'))
        window.location.search = '?' + searchParams.toString()
    })
})
